export default __webpack_public_path__ + "static/media/iosWhite.ed567b5e.svg";